// footer.config.ts
import type { FooterConfig } from "./Footer.types";

export const defaultFooterConfig: FooterConfig = {
    logo: {
        src: "/images/logo.svg",
        alt: "Defy Medical",
        className: "mb-8",
    },
    companyName: "Defy Medical",
    disclaimer:
        "All information contained within this site is for informational purposes only. It is not intended to diagnose, treat, cure, or prevent any health problem. No action should be taken solely on the contents of this website or our testimonials. Always consult a physician or qualified health professional on any matters regarding your health or on any opinions expressed within this website. Results vary from patient to patient.",
    socialLinks: [
        {
            href: "https://facebook.com/defymedical",
            label: "Facebook",
            icon: "bi-facebook",
            hoverColor: "hover:text-blue-500",
        },
        {
            href: "https://instagram.com/defymedical",
            label: "Instagram",
            icon: "bi-instagram",
            hoverColor: "hover:text-pink-500",
        },
        {
            href: "https://twitter.com/defymedical",
            label: "Twitter",
            icon: "bi-twitter-x",
            hoverColor: "hover:text-gray-400",
        },
        {
            href: "https://linkedin.com/company/defymedical",
            label: "LinkedIn",
            icon: "bi-linkedin",
            hoverColor: "hover:text-blue-700",
        },
        {
            href: "https://youtube.com/defymedical",
            label: "YouTube",
            icon: "bi-youtube",
            hoverColor: "hover:text-red-600",
        },
    ],
    navigationColumns: [
        {
            title: "",
            links: [
                { label: "Patients bill of rights", href: "/patients-bill-of-rights" },
                { label: "Vendor Information", href: "/vendor-information" },
            ],
        },
    ],
    legalLinks: {
        privacyPolicy: "/Privacy",
        termsOfService: "/Tos",
    },
    showSocialLinks: true,
    showDisclaimer: true,
    showLegalLinks: true,
    backgroundColor: "bg-primary",
    copyrightBackgroundColor: "bg-[var(--color-gray-950)]",
};